export default __webpack_public_path__ + "static/media/andrea_full_large.058374f4.png";